import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';
import { App } from '@df/core/app';
import { Logger } from '@df/core/service/logger';
import { Basket } from '@df/session/api/basket/basket';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { StoreCreditService } from '../module/store-credit/store-credit.service';
import { CheckoutFormComponent } from './checkout-form.component';

@Component({
    selector: 'checkout-summary-step',
    templateUrl: './checkout-summary-step.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class CheckoutSummaryStepComponent extends CheckoutStepComponentDef implements OnInit, OnDestroy {
    protected override subscriptions = new Subscription();

    constructor(
        protected override checkoutFormComponent: CheckoutFormComponent,
        ngEl: ElementRef,
        app: App,
        protected override logger: Logger,
        protected override scrollToErrorService: ScrollToErrorService,
        protected basket: Basket,
        public override changeDetectorRef: ChangeDetectorRef,
        protected storeCredit: StoreCreditService
    ) {
        super(checkoutFormComponent, ngEl, app, logger, scrollToErrorService);

        this.subscriptions.add(this.basket.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    override ngOnInit() {
        [this.checkoutFormComponent.saveShippingAddressStatus, this.checkoutFormComponent.saveShippingMethodStatus].forEach(status => {
            this.subscriptions.add(
                status.subscribe(() => {
                    if (status.busy) {
                        this.changeDetectorRef.detectChanges();
                    } else {
                        setTimeout(() => this.changeDetectorRef.detectChanges(), 100);
                    }
                })
            );
        });
    }

    override ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get display(): boolean {
        return this.checkoutFormComponent.displaySummaryStep;
    }
}
